// extracted by mini-css-extract-plugin
export default {"employee":"employee_employee__Gwg3C","name":"employee_name__gMzAt","phone":"employee_phone__go20Y","login":"employee_login__7TMGj","actions":"employee_actions__7vMh2"};